import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Flex, ProgressCircle } from '@spotify-internal/encore-web';
import {
  CommentFragment,
  CommentQuery,
  CommentQueryVariables,
  useCommentQuery,
  withStandardGetHook,
} from '@spotify/confidence-graphql';

const useComment = withStandardGetHook<
  CommentQuery,
  CommentFragment,
  'comment',
  CommentQueryVariables
>(useCommentQuery, 'comment');

export const CommentsHandler = () => {
  const { commentId } = useParams();
  const navigate = useNavigate();
  const { comment, error, isLoading } = useComment({
    name: `comments/${commentId}`,
  });
  const resource = comment?.resource;
  const name = comment?.name;

  useEffect(() => {
    if (isLoading) return;
    if (error || !resource || !name) {
      navigate('/', { replace: true });
      return;
    }

    navigate(
      {
        pathname: `/${resource.replace('/instances', '')}`,
        search: new URLSearchParams({ comment: name }).toString(),
      },
      { replace: true },
    );
  }, [error, isLoading, name, navigate, resource]);

  return (
    <Flex justifyContent="center" padding="base">
      <ProgressCircle aria-label="Loading comment" />
    </Flex>
  );
};
